/* tslint:disable */

export const Copy = {
  pickupTextDefault: 'Look for the Noble Crown at the Mezzanine Bar. Show this order number to the bartender.',
  deliveryTextDefault: 'Your order is on the way! Show this order number to your server when they arrive.',
};
